module.exports = "#version 300 es\nprecision highp float;\n\nin vec4 fs_Col;\nin vec4 fs_Pos;\n\nout vec4 out_Col;\n\nvoid main()\n{\n    float dist = 1.0 - (length(fs_Pos.xyz) * 2.0);\n    out_Col = vec4(dist) * fs_Col;\n    out_Col = vec4(vec3(fs_Col), 1.0);\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/shaders/instanced-frag.glsl
// module id = 77
// module chunks = 0